import { createContext, useContext, useEffect } from 'react';

import type { FloatingResourceAddContext } from './types';

const defaultContextValue: FloatingResourceAddContext = {
    clearOpenRequest: () => {
        throw new Error('FloatingResourceAddProvider not found');
    },
    openRequest: null,
    requestOpen: () => {
        throw new Error('FloatingResourceAddProvider not found');
    },
    setVisible: () => {
        throw new Error('FloatingResourceAddProvider not found');
    },
    visible: true
};

export const context = createContext<FloatingResourceAddContext>(defaultContextValue);

export const useFloatingResourceAddContext = (visible?: boolean) => {
    const {
        clearOpenRequest,
        openRequest,
        requestOpen,
        setVisible,
        visible: currentVisible
    } = useContext(context);

    useEffect(() => {
        if (visible !== undefined) {
            setVisible(visible);

            return () => {
                setVisible(true);
            };
        }
    }, [setVisible, visible]);

    return {
        clearOpenRequest,
        context,
        openRequest,
        requestOpen,
        setVisible,
        visible: currentVisible
    };
};
